import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'uk-pims-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  // TODO: Angular 19 WARNING: Unused import. Delete if unnecessary
  imports: [RouterOutlet],
})
export class AppComponent {
  title = 'pims';
  BODACDC_3966 = FEATURE_BODACDC_3966;
}
